// DepositContext.js
import React, { createContext, useState } from 'react';

export const DepositContext = createContext();

export const DepositProvider = ({ children }) => {
    const [depositData, setDepositData] = useState({
        currentPage: 1,
        startRange: '',
        endRange: '',
        checkStart:'',
        checkEnd:'',
    });

    return (
        <DepositContext.Provider value={{ depositData, setDepositData }}>
            {children}
        </DepositContext.Provider>
    );
};